import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/AuthModal.css';

function AuthModal({ type, onClose, onAuthenticated }) {
  const navigate = useNavigate();

  // State variables
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [currentType, setCurrentType] = useState(type);
  const [authError, setAuthError] = useState('');

  // Calculate age
  const calculateAge = (birthDate) => {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
      age--;
    }
    
    return age;
  };

  // Validation
  const validateEmail = (email) => {
    const validDomains = [
      '@gmail.com', '@gmail.com.tr',
      '@hotmail.com', '@hotmail.com.tr',
      '@outlook.com', '@outlook.com.tr',
      '@yahoo.com', '@yahoo.com.tr',
      '@icloud.com', '@icloud.com.tr',
      '@yandex.com', '@yandex.com.tr',
      '@msn.com', '@msn.com.tr'
    ];
    const domain = email.substring(email.indexOf('@'));
    return validDomains.includes(domain.toLowerCase());
  };

  // Form submission handling
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setEmailError('Geçersiz e-posta adresi. Lütfen mail adresinizi kontrol edin.');
      return;
    }
    setEmailError('');

    if (currentType === 'signup') {
      const age = calculateAge(`${year}-${month}-${day}`);
      if (age < 12) {
        setAuthError('12 yaşından küçükler kayıt olamaz.');
        return;
      }
    }

    try {
      if (currentType === 'login') {
        const response = await api.post('/auth/login', { email, password });
        if (response.status === 200) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userId', response.data.user_id);
          localStorage.setItem('username', response.data.username); 
         
          if (onAuthenticated) {
            onAuthenticated();
          }
          navigate('/dashboard');
          setAuthError('');
        } else {
          setAuthError('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
        }
      } else {
        if (password !== confirmPassword) {
          setAuthError('Şifreler eşleşmiyor!');
          return;
        }
        if (!agreeTerms) {
          setAuthError('Lütfen hizmet şartları ve gizlilik politikasını kabul edin.');
          return;
        }
        const response = await api.post('/auth/register', {
          email,
          username,
          password,
          birthDate: `${year}-${month}-${day}`
        });
        if (response.status === 201) {
          setRegistrationSuccess(true);
          setAuthError('');
        } else {
          setAuthError('Kayıt başarısız. Lütfen bilgilerinizi kontrol edin.');
        }
      }
    } catch (error) {
      console.error('Hata:', error.response ? error.response.data : error.message);
      setAuthError(error.response ? error.response.data.message : 'Bir hata oluştu!');
    }
  };

  const switchToLogin = () => {
    setCurrentType('login');
    setRegistrationSuccess(false);
  };

  const switchToSignup = () => {
    setCurrentType('signup');
    setRegistrationSuccess(false);
  };

  const generateOptions = (start, end) => {
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const days = generateOptions(1, 31);
  const months = [
    'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
    'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
  ];
  const currentYear = new Date().getFullYear();
  const years = generateOptions(currentYear - 100, currentYear).reverse();

  return (
    <div className="auth-modal-overlay">
      <div className="auth-modal">
        <button className="close-button" onClick={onClose}>×</button>
        
        <h2>{currentType === 'login' ? "Librozi'ye giriş yapın" : "Librozi'ye kaydolun"}</h2>
        
        {authError && <div className="error-message" style={{ color: 'red' }}>{authError}</div>}
        
        {registrationSuccess ? (
          <div className="success-message">
            <p>Kayıt işleminiz başarıyla tamamlandı!</p>
            <p>Artık giriş yapabilirsiniz.</p>
            <button 
              className="auth-button" 
              onClick={switchToLogin}
            >
              Tamam
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="E-posta"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {emailError && <div className="error-message">{emailError}</div>}
            
            {currentType === 'signup' && (
               <>
                <input
                  type="text"
                  placeholder="Kullanıcı adı"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
                <div className="birthday-selector">
                  <select value={day} onChange={(e) => setDay(e.target.value)} required>
                    <option value="">Gün</option>
                    {days.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                  <select value={month} onChange={(e) => setMonth(e.target.value)} required>
                    <option value="">Ay</option>
                    {months.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
                  </select>
                  <select value={year} onChange={(e) => setYear(e.target.value)} required>
                    <option value="">Yıl</option>
                    {years.map(y => <option key={y} value={y}>{y}</option>)}
                  </select>
                </div>
              </>
            )}
            
            <input
              type="password"
              placeholder="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            
            {currentType === 'signup' && (
              <>
                <input
                  type="password"
                  placeholder="Şifreyi tekrar girin"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <div className="terms-agreement">
                  <input
                    type="checkbox"
                    id="agreeTerms"
                    checked={agreeTerms}
                    onChange={(e) => setAgreeTerms(e.target.checked)}
                    required
                  />
                  <label htmlFor="agreeTerms">
                    <a href="/agreements" target="_blank">Hizmet koşulları</a> ve 
                    <a href="/agreements" target="_blank"> gizlilik politikası</a>nı okudum ve kabul ediyorum.
                  </label>
                </div>
              </>
            )}
            
            <button type="submit" className="auth-button">
              {currentType === 'login' ? 'Giriş yap' : 'Kayıt ol'}
            </button>
          </form>
        )}


        {currentType === 'login' && (
          <button 
            onClick={() => {
              onClose();
              navigate('/resetpassword');
            }}
            className="forgot-password"
          >
            Şifrenizi mi unuttunuz?
          </button>
        )}
        {currentType === 'login' ? (
          <div className="switch-auth">
            <p>Hesabınız yok mu? <button onClick={switchToSignup} className="switch-button">Hemen kaydol</button></p>
          </div>
        ) : (
          <div className="switch-auth">
            <p>Hesabınız var mı? <button onClick={switchToLogin} className="switch-button">Giriş yap</button></p>
          </div>
        )}
      </div>
    </div>
  );
}

export default AuthModal;